var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-image",attrs:{"flat":""}},[_c('img',{staticClass:"d-block card-image-img",attrs:{"src":_vm.url}}),_c('div',{staticClass:"d-flex align-end px-3 px-sm-4 pb-3 card-image-caption"},[_c('div',{staticClass:"white--text text-body-2 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }